import React, {Dispatch, SetStateAction, useRef, useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
// import IconMore from '../../../../media/shared-access/ic-more.svg'
// import {useIntl} from 'react-intl'
import '../style/contact-list.scss'
import {deleteContact} from '../core/_requests'
import {useAuth} from '../../../../app/modules/auth'
import {toast} from 'react-toastify'
import DeleteModal from './delete-confirmation'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
// import {ScrollTop} from '../../../../_metronic/layout/components/scroll-top'
import {useIntl} from 'react-intl'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

interface UserProfileProps {
  profileImageUrl: string
  userName: string
  userEmail: string
  setselectedContact: any
  user: any
  handleContactOptions: any
  setcontacts: any
  isSubmittingContact: any
  menuTop: any
  selectedContact: any
}

const UserProfile: React.FC<UserProfileProps> = ({
  profileImageUrl,
  userName,
  userEmail,
  setselectedContact,
  user,
  handleContactOptions,
  setcontacts,
  isSubmittingContact,
  menuTop,
  selectedContact,
}) => {
  const {companyId, currentUser} = useAuth()
  const {formatMessage} = useIntl()
  const hasProfileImage = profileImageUrl !== ''

  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [menuVisible, setMenuVisible] = useState(false) // eslint-disable-line
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  // const [menuTop, setMenuTop] = useState('100%')
  // const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth <= 924)

  // function handleMenuVisible() {
  //   setMenuVisible(() => !menuVisible)
  // }

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      const {
        data: {success, errors},
      } = await deleteContact(companyId!, user.id)
      if (success) {
        toast.success(formatMessage({id: 'Contact deleted successfully.'}))
        setcontacts((p: any) => p.filter((contact: any) => contact.id !== user.id))
        setselectedContact({})
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ContactDeletedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              contact_id: user.id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ContactDeleteFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              contact_id: user.id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ContactDeleteFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            contact_id: user.id,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
      handleContactOptions('Detail')
    }
  }

  // const handleClickOutside = (event: MouseEvent) => {
  //   if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
  //     setMenuVisible(false)
  //   }
  // }
  // useEffect(() => {
  //   document.addEventListener('mousedown', handleClickOutside)
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside)
  //   }
  // }, [])
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const wrapperRef = useRef<HTMLDivElement>(null)

  const isSelected = selectedContact?.id === user.id

  return (
    <div
      ref={wrapperRef}
      className={`contact-list-item d-flex flex-stack py-3 px-3 rounded bg-hover-light text-dark ${
        isSelected ? 'bg-light' : ''
      } `}
      style={{
        width: '100%',
        marginBottom: '5px',
      }}
    >
      <div
        className='d-flex align-items-center'
        style={{width: '80%', overflow: 'hidden'}}
        onClick={() => {
          if (!isSubmittingContact) {
            setselectedContact(user)
            handleContactOptions('Detail')
          }
        }}
      >
        <div className='symbol symbol-40px symbol-circle'>
          {hasProfileImage ? (
            <img alt='Pic' src={profileImageUrl} />
          ) : (
            <span className='symbol-label bg-light-primary text-primary fw-bolder'>
              {userName.charAt(0)}
            </span>
          )}
        </div>
        <Link to='#' className=''>
          <div className='ms-4'>
            <div
              className={`fw-bold text-dark ${!isSelected ? 'text-light' : 'text-hover-primary'}`}
              style={{}}
            >
              {userName}
            </div>
            <div
              className={`fw-normal fs-7 text-muted ${
                !isSelected ? 'text-muted' : 'text-hover-primary'
              }`}
              style={{overflow: 'hidden'}}
            >
              {userEmail}
            </div>
          </div>
        </Link>
      </div>
      <div className='position-relative'>
        <div
          className='p-2 cursor-pointer bg-white rounded-2 d-flex justify-content-center align-items-center'
          onClick={() => setShowKebabMenu(!showKebabMenu)}
        >
          <img src={threeDots} alt='' width={12} height={12} />
        </div>
        {showKebabMenu && (
          <div
            className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
            style={{top: '40px', right: 0}}
            ref={dropdownRef}
          >
            <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
              <button
                type='button'
                className='m-0 border-0 bg-transparent text-primary font-size-12 hover-muted'
                onClick={() => {
                  if (!isSubmittingContact) {
                    setselectedContact(user)
                    handleContactOptions('Detail')
                    setMenuVisible(false)
                  }
                }}
              >
                {formatMessage({id: 'View'})}
              </button>
            </div>
            <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
              <button
                type='button'
                className='m-0 border-0 bg-transparent text-dark font-size-12 hover-muted'
                onClick={() => {
                  if (!isSubmittingContact) {
                    setselectedContact(user)
                    handleContactOptions('Edit')
                    setMenuVisible(false)
                  }
                }}
              >
                {formatMessage({id: 'Edit'})}
              </button>
            </div>
            <div className='border-0 border-gray-300 p-2 dropdown-items w-100'>
              <button
                type='button'
                className='m-0 border-0 bg-transparent text-danger font-size-12 hover-muted'
                onClick={() => {
                  if (!isSubmittingContact) {
                    setIsDeleteModalOpen(true)
                    setMenuVisible(false)
                  }
                }}
              >
                {formatMessage({id: 'Delete'})}
              </button>
            </div>
          </div>
        )}
      </div>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          if (!isDeleting) {
            setIsDeleteModalOpen(false)
          }
        }}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />
    </div>
  )
}

interface ContactListProps {
  setselectedContact: Dispatch<SetStateAction<{}>>
  contacts: any
  handleContactOptions: any
  setcontacts: any
  isUserConnected: any
  isSubmittingContact: any
  isContactLoading: any
  connectorLoading: any
  nextContactPage: any
  getAllContacts: any
  selectedContact: any
}

export const ContactList: React.FC<ContactListProps> = ({
  setselectedContact,
  contacts,
  handleContactOptions,
  setcontacts,
  isUserConnected,
  isSubmittingContact,
  isContactLoading,
  connectorLoading,
  nextContactPage,
  getAllContacts,
  selectedContact,
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const {formatMessage} = useIntl()
  const [filteredContacts, setFilteredContacts] = useState(contacts)
  const [contactPositions, setContactPositions] = useState<{[key: number]: string}>({}) // eslint-disable-line

  const handleScroll = () => {
    const container = document.getElementById('kt_contacts_list_body')
    console.log(
      'checking scroll above',
      container?.scrollHeight,
      container?.scrollTop,
      container?.clientHeight
    )
    if (container) {
      const isAtBottom =
        container.scrollHeight - container.scrollTop === container.clientHeight + 0.5
      if (isAtBottom && !isContactLoading && nextContactPage) {
        getAllContacts()
        console.log('checking scroll', nextContactPage)
      }
    }
  }

  useEffect(() => {
    const container = document.getElementById('kt_contacts_list_body')
    if (container) {
      container.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isContactLoading]) // eslint-disable-line

  useEffect(() => {
    if (contacts) {
      setFilteredContacts(
        contacts.filter((user: any) =>
          user?.givenName?.toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    }
  }, [searchQuery, contacts])

  return (
    <div className='card' id='kt_contacts_list'>
      <div className=' mx-4 pt-4' id='kt_contacts_list_header'>
        {/* <form className='d-flex align-items-center position-relative w-100 m-0'>
          <input
            type='text'
            className='form-control fw-normal'
            name='search'
            placeholder={formatMessage({ id: 'Search contacts' })}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form> */}
        <form className='align-items-center d-flex position-relative w-100 w-md-auto'>
          <span className='svg-icon svg-icon-3 position-absolute ms-2'>
            <img src={searchIcon} alt='Search icon' />
          </span>
          <input
            type='text'
            className='bg-body bg-light form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 py-3 border border-2'
            name='search'
            placeholder={formatMessage({id: 'Search contacts'})}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>
        <div
          className=''
          id='kt_contacts_list_body'
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            width: '100%',
            margin: '0px',
            marginTop: '15px ',
          }}
        >
          <div
            id='kt_contacts_list_body'
            style={{
              height: '55vh',
              width: '100%',
              padding: '0px !important',
            }}
          >
            {isContactLoading || connectorLoading
              ? Array(5)
                  .fill(null)
                  .map((_, index) => (
                    <div key={index} className='w-full'>
                      <Skeleton
                        height={60}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ))
              : filteredContacts?.map((user: any, index: any) => (
                  <UserProfile
                    key={index}
                    profileImageUrl={user?.pictureUrl}
                    userName={user?.givenName || ''}
                    user={user}
                    userEmail={user?.emails?.length > 0 && user?.emails[0]?.email}
                    setselectedContact={setselectedContact}
                    handleContactOptions={handleContactOptions}
                    setcontacts={setcontacts}
                    isSubmittingContact={isSubmittingContact}
                    menuTop={contactPositions[index] || '100%'}
                    selectedContact={selectedContact}
                  />
                ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactList
